module.exports = __webpack_public_path__ + "static/media/3219A3_0_0.ea975029.woff";